module.exports = __webpack_public_path__ + "img/signup-carousel-fourth@3x.848f4cbe.png";